<style>
.support-index .st-body .ticket-content .ticket-description {
  height: auto;
}
</style>
<template>
  <div class="support-ticket" @click="seleccionar">
    <div class="st-meta">
      <i class="os-icon os-icon-unlock" v-if="despachoe.estado == 'A'"></i>
      <i class="os-icon os-icon-lock" v-if="despachoe.estado == 'B'"></i>
      <div class="status-pill green" v-if="despachoe.estado == 'A'"></div>
      <div class="status-pill red" v-if="despachoe.estado == 'B'"></div>
    </div>
    <div class="st-body" style="dispaly: block">
      <div class="ticket-content">
        <span>
          <span class="font-weight-bold">Despacho: #</span
          >{{ despachoe.numero }} - <span class="font-weight-bold">Ruta: #</span
          >{{ despachoe.ruta_despacho }}
        </span>
        <div class="ticket-description">
          <span>
            {{ despachoe.tienda.nombre }} -
            {{ despachoe.usuario.username }}
          </span>
        </div>
        <div class="os-progress-bar primary">
          <div class="bar-labels">
            <div class="bar-label-left">
              <span>Completado:</span>
            </div>
            <div class="bar-label-right col-12">
              <div class="progress">
                <div
                  class="
                    progress-bar progress-bar-striped
                    bg-success
                    progress-bar-animated
                  "
                  role="progressbar"
                  :style="{
                    width: despachoe.porc_completado + '%',
                  }"
                >
                  <a style="color: black">{{ despachoe.porc_completado }}%</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="st-foot text-right">
      <span class="label">Fecha:</span>
      <span class="value">
        {{ despachoe.fecha_creacion | moment("DD/MM/YYYY HH:MM:ss a") }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: ["despachoe"],
  computed: {},
  mounted() {},
  methods: {
    seleccionar() {
      let self = this;
      self.$emit("seleccion", self.despachoe.id);
    },
  },
};
</script>
